import { createDeformedCube } from "./CubeBase";

// 立方体モチーフ（cube と同一の見た目）。faceColors で面着色、errorEdges で辺の強調表示
export function createCube0(faceColors, errorEdges) {
  return createDeformedCube((x, y, z) => [x, y, z], faceColors, errorEdges);
}
